import React from "react"

import AccountYearFormComponent from "./account-year-form-component"

class AccountYearFormContainer extends React.Component {
  state = {
    step: 1,
    percentile: false
  };

  render() {
    const percentile =
      this.state.percentile == undefined ? true : this.state.percentile
    return (
      <AccountYearFormComponent
        step={this.state.step}
        account={this.props.account}
        type={this.props.type}
        value={this.props.value}
        submitting={this.props.submitting}
        confirm={this.state.confirm}
        induceds={this.props.induceds}
        percentile={percentile}
        title={this.state.title}
        checked={this.state.checked}
        handleCheck={this._handleCheck.bind(this)}
        handleHideModel={this.handleHideModel.bind(this)}
        onChange={this._handleInputChange.bind(this)}
        handleCheckType={this.handleCheckType.bind(this)}
        onPrevious={this._handlePrevious.bind(this)}
        onDelete={this._handleDeleteValue.bind(this)}
        onCancelEdit={this.props.onCancelEdit}
        onSubmit={this._handleSubmit.bind(this)}
        handleConfirm={this.handleConfirm.bind(this)}
      />
    )
  }
  _handleInputChange(event) {
    this.setState({ amount: event.target.value })
  }
  _handlePrevious() {
    this.setState({ step: 1 })
  }
  _handleCheck(name) {
    if (name == "percentile") {
      this.setState({ percentile: true })
    } else {
      this.setState({ percentile: false })
    }
  }
  handleConfirm(e, value) {
    e.preventDefault()
    this.setState({ confirm: false })
    if (value == "1") {
      if (this.state.title == "Ajouter") {
        const percentile =
          this.state.percentile == undefined ? true : this.state.percentile
        this.props.onSubmit(this.state.amount, percentile)
      } else if (this.state.title == "Effacer") {
        this.props.onDelete()
      }
    } else {
      this.props.onCancelEdit()
    }
  }
  _handleSubmit(e) {
    e.preventDefault()
    if (this.state.step == 1) {
      this.setState({
        step: 2,
      })
    } else {
      this.setState(
        {
          // confirm: true,
          title: "Ajouter",
        },
        () => this.handleConfirm(e, "1")
      )
      // this.props.onSubmit(this.state.amount, this.state.percentile)
    }
  }
  handleCheckType(e) {
    this.setState({
      checked: e.target.value == "1" ? false : true,
      value: e.target.value,
    })
  }
  handleHideModel() {
    this.setState({
      confirm: false,
    })
  }
  _handleDeleteValue(e) {
    e.preventDefault()
    this.setState(
      {
        // confirm: true,
        title: "Effacer",
      },
      () => this.handleConfirm(e, "1")
    )
    // this.props.onDelete()
  }
}

export default AccountYearFormContainer



// WEBPACK FOOTER //
// ./src/component/scenarii/common/account-year-form-container.js